import View from "./View";
import { ease } from './helpers/EaseHelper'
import { updateSpriteSheet } from './helpers/DOMHelper'

/**
 * class CloseButton
 */

const COUNT_FRAME_STATIC = 20
const COUNT_FRAME_OVER = 40
const COUNT_FRAME_OUT = 54
const WIDTH = '139px'

class CloseButton extends View {

  constructor(el) {
    super(el)
    updateSpriteSheet(this.view, WIDTH, 0)
  }

  showHandler (resolve) {
    ease({ value: 0 })
      .to({ value: COUNT_FRAME_STATIC }, 800)
      .onUpdate(o => { updateSpriteSheet(this.view, WIDTH, o.value) })
      .onComplete(() => {
        this.view.addEventListener('mouseover', this.onOver)
        this.view.addEventListener('mouseout', this.onOut)
        resolve()
      })
      .start()
  }

  hideHandler (resolve) {
    this.view.removeEventListener('mouseover', this.onOver)
    this.view.removeEventListener('mouseout', this.onOut)
    ease({ value: COUNT_FRAME_OVER })
      .to({ value: 0 }, 700)
      .onUpdate(o => { updateSpriteSheet(this.view, WIDTH, o.value) })
      .onComplete(() => {
        updateSpriteSheet(this.view, WIDTH, 0)
        resolve()
      })
      .start()
  }

  onOver = () => {
    ease({ value: COUNT_FRAME_STATIC })
      .to({ value: COUNT_FRAME_OVER }, 600)
      .onUpdate(o => { updateSpriteSheet(this.view, WIDTH, o.value) })
      .start()
  }

  onOut = () => {
    ease({ value: COUNT_FRAME_OVER })
      .to({ value: COUNT_FRAME_OUT }, 600)
      .onUpdate(o => { updateSpriteSheet(this.view, WIDTH, o.value) })
      .start()
  }

}

export default CloseButton


// WEBPACK FOOTER //
// ./src/scripts/CloseButton.js